import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-common-add-permission-modal',
  templateUrl: './common-add-permission-modal.component.html',
  styleUrls: ['./common-add-permission-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CommonAddPermissionModalComponent {

}
